// 1. 导入Vue
import Vue from 'vue'
import _ from 'lodash'
import { dateFormat } from '@/utils/date'

// 根据 precision（精度） 向下舍入 number。（注： precision（精度）可以理解为保留几位小数。）
// Vue.filter('floor', function(number, precision = 2) {
//   return _.floor(number, precision)
// })

// 根据 precision（精度） 向上舍入 number。（注： precision（精度）可以理解为保留几位小数。）
// Vue.filter('ceil', function(number, precision = 2) {
//   return _.ceil(number, precision)
// })

// 根据 precision（精度） 四舍五入 number。
// Vue.filter('round', function(number, precision = 2) {
//   return _.round(number, precision)
// })

// money
Vue.filter('money', function(number) {
  if (!number) return '0.00'
  number = String(_.ceil(number, 2))
  let int = number.split('.')[0]
  let float = number.split('.')[1] || ''
  switch (float.length) {
    case 0:
      float = '00'
      break
    case 1:
      float = `${float}0`
      break
  }
  return `${int}.${float}`
})

/**
 * 格式化时间
 */
Vue.filter('dateFormat', function(date) {
  return dateFormat(date)
})

// 根据 precision（精度） 四舍五入 number。
Vue.filter('round', function(number, precision = 2) {
  return _.round(number, precision)
})
